import triggerTypes from '../constants/trigger-types';
import findAllFor from './find-all-for';

function findAllHoveredFor(element) {
  return findAllFor(element, triggerTypes.HOVER);
}

export default findAllHoveredFor;
